import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Página Não Encontrada"
        description="A página que você está procurando não existe ou foi movida. Volte para a página inicial da GodoyProd."
        keywords="404, página não encontrada, GodoyProd"
        noindex
        canonicalPath="/404"
      />
      <div className="min-h-screen bg-godoy-black">
        <Navbar />

        <div className="flex flex-col items-center justify-center pt-40 pb-28 text-center">
          <div className="w-16 h-16 mx-auto mb-6">
            <img
              src="https://pub-bc092def332d4fb180f02b510802da8e.r2.dev/LogoGP.png"
              alt="GodoyProd"
              className="w-full h-full object-contain opacity-50"
            />
          </div>
          <h1 className="font-serif text-5xl md:text-7xl font-bold text-godoy-gold mb-4">
            404
          </h1>
          <p className="text-godoy-cream text-xl mb-2">Página não encontrada</p>
          <p className="text-godoy-lightgray text-sm max-w-md mx-auto mb-8">
            A página que você está procurando não existe ou foi movida.
            Verifique o endereço ou volte para a página inicial.
          </p>
          <Link
            to="/"
            className="px-8 py-3 bg-godoy-gold text-godoy-black font-semibold rounded-md hover:bg-godoy-goldlight transition-all"
          >
            Voltar para o Início
          </Link>
        </div>

        <Footer />
      </div>
    </>
  );
}